<template>
  <div>
    <b-modal
      class="modal-update-attendance"
      id="modal-update-attendance"
      hide-footer
      centered
      no-close-on-esc
      no-close-on-backdrop
      size="s"
      title="Update Attendance"
    >
      <div class="mb-3">
        <h5>{{ presence.name }}</h5>
        <div class="info-employee">
          <div class="justify-content-between d-flex text-muted pl-2 pr-2 mb-2">
            <div>
              Employee ID
            </div>
            <div>
              {{ presence.employeeNo }}
            </div>
          </div>
          <div class="justify-content-between d-flex text-muted pl-2 pr-2">
            <div>
              Postion
            </div>
            <div>
              {{ presence.position }}
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <div class="select-date">
          <b-form-group
            label="Date"
          >
            <custom-select
              placeholder="Select Date(s)"
              :options="optionsDate"
              v-model="selectedDate"
            />
          </b-form-group>
        </div>
        <div class="ml-3 mt-4 text-white">
          <b-button variant="warning" @click="confirm">
            Confirm
          </b-button>
        </div>
      </div>
      <div v-show="showSave">
        <b-form-group
          label="Attendance Type"
        >
          <custom-select
            placeholder="Select Attendance Type"
            :options="type"
            v-model="selectedTypeAttendance"
          />
        </b-form-group>
      </div>
      <div>
        <b-button v-show="showSave" variant="warning" block @click="saveAttendance">
          Save
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import api from '@/api'

export default {
  props: {
    typeAttendance: {
      type: Array,
      default: () => []
    },
    presence: {
      type: Object,
      default: () => {}
    },
    month: {
      type: Number,
      default: () => null
    },
    dataAttendance: {
      type: Object,
      default: () => {}
    },
    attendanceMontly: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: {
        attendanceTypeId: '',
        attendanceDetailId: ''
      },
      data: {},
      selectedTypeAttendance: [],
      type: [],
      optionsDate: [],
      selectedDate: '',
      showSave: false
    }
  },
  methods: {
    async getDetailByFilter(id) {
      try {
        const { data } = await api.presence.listDetail({
          page: 1,
          pageSize: 1,
          Filters: `attendanceId==${id}, attendanceDate==${this.selectedDate}`
        })
        this.data = []
        this.data = data.data[0]
        this.selectedTypeAttendance = this.convertTypeIdToString(this.data.attendanceTypeId)
      } catch (error) {
        console.log(error)
      }
    },
    getCurrentFormattedDate() {
      const currentDate = new Date()
      const year = currentDate.getFullYear()
      const day = String(currentDate.getDate()).padStart(2, '0')

      return `${year}-${this.month}-${day}`
    },
    convertTypeIdToString(id) {
      const typeAttendance = this.typeAttendance.find(item => item.id === id)
      return typeAttendance.name
    },
    confirm() {
      this.getDetailByFilter(this.presence.attendanceId)
      this.showSave = true
    },
    saveAttendance() {
      this.typeAttendance.forEach(item => {
        if (item.name === this.selectedTypeAttendance) {
          this.form.attendanceTypeId = item.id
        }
      })
      this.form.attendanceDetailId = this.data.id
      this.$emit('update', this.form)
      this.$bvModal.hide('modal-update-attendance')
      console.log(this.form)
      this.form = {
        attendanceTypeId: '',
        attendanceDetailId: ''
      }
      this.selectedTypeAttendance = []
    }
  },
  watch: {
    typeAttendance: {
      handler() {
        this.typeAttendance.forEach(item =>
          this.type.push(item.name)
        )
      },
      immediate: true
    },
    dataAttendance: {
      handler() {
        const typeAttendance = this.typeAttendance.find(item => item.id === this.dataAttendance.attendanceTypeId)
        this.selectedTypeAttendance = typeAttendance.name
      },
      deep: true
    },
    attendanceMontly: {
      handler() {
        this.optionsDate = []
        this.attendanceMontly.forEach(item => {
          this.optionsDate.push(item.attendanceDate)
        })
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.select-date{
  width: 100vh;
}
</style>
